module.exports = __webpack_public_path__ + "static/icon-5eb9b2a74cf00c699699b23bfbf1290f.png";